/**
 * Log/Report
 * 현재 상태
 * SD-WAN 터널 상태
 * 토폴로지 상태
 * 대시보드 상단 메뉴 Store
 *
 * @since 2022-12-09
 * @author wj_tams_dev01
 */

export const state = () => ({
  refreshTime: 10
})

export const mutations = {
  initTopStore (state) {
    state.refreshTime = 10
  },
  setDashboardTimer (state, timerValue) {
    state.refreshTime = timerValue
  }
}
export const actions = {
}

export const getters = {}
export const strict = false
